import styled from "styled-components";
import { Breadcrumb } from "antd";

export const BreadcrumbWrapper = styled.div`
  width: 100%;
  margin: 37px 0 30px 0;
  background-color: ${props => props.theme.backgroundColor.white};
  @media only screen and (max-width: 991px) {
    margin: 0 0 20 0px;
  }
`;

export const BreadCrumArrow = styled.span`
 color: ${props => props.theme.fontColors.textColor};
`;

export const Breadcrumbs = styled(Breadcrumb)`
  .ant-breadcrumb-separator {
    margin: 0 5px;
  }
  .ant-breadcrumb-link {
    display: inline-block;
    font-size: ${props => props.theme.fontSize.tertiary};
    color: ${props => props.theme.fontColors.textColor};
    line-height: 21px;
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    @media only screen and (min-width: 320px) and (max-width: 425px) {
      font-size: 12px;
    }
  }
  .ant-breadcrumb-link a {
    color: ${props => props.theme.fontColors.textColor};
    text-decoration: none;
    &:hover {
      color: ${props => props.theme.fontColors.primary} !important;
      text-decoration: underline;
    }
  }
  .ant-breadcrumb-link span {
    color: ${props => props.theme.fontColors.textColor};
  }
`;

export const BreadcrumbContainer = styled.div`
  margin: 0px 0px 30px 0;
  padding-top:25px;
  @media only screen and (max-width: 768px) {
      margin: 0px 0px 40px 0px;
      padding-top:34px;
  }
  @media only screen and (max-width: 991px) {
    padding-top:0px;
    margin: 0px 0px 40px 0px;
    display: none;
  } 
`;
